<template>
  <Form ref="attendanceManagerForm" :model="attendanceManager" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="attendanceManager.id" type="hidden"/>
    <FormItem  :label="this.$t('ipms.attendance-manager.userId.label')" prop="userId">
      <Select v-model="attendanceManager.userId" :placeholder="$t('ipms.attendance-manager.userId.holder')">
        <Option v-for="item in attManagerTree" :value="item.userId" :key="item.userId">{{ item.nickName }}</Option>
      </Select>
    </FormItem>
    <FormItem  :label="this.$t('ipms.attendance-manager.attendanceGroup.label')" prop="attendanceGroup">
      <Select v-model="attendanceManager.attendanceGroup" :placeholder="$t('ipms.attendance-manager.attendanceGroup.holder')">
        <Option v-for="item in dict.attendanceGroup" :value="item.dictKey" :key="item.dictValue">{{item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('ipms.attendance-manager.remark.label')" prop="remark">
      <Input v-model="attendanceManager.remark" :placeholder="$t('ipms.attendance-manager.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

  </Form>
</template>
<script>
import dict from '@/components/dict'
import api from '@/api'

export default {
  dictParams: ['attendanceGroup'],
    components: {
      'dict-tag': dict
    },
  data () {
    return {
      attManagerTree:[],
      attendanceManager: {
        id: null,
        userId: null,
        attendanceGroup: 0,
        remark: null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    treeSelect(){
      api.ipms.AttendanceManager.treeselect().then(data=>{
        this.attManagerTree=data
         console.log(data);
      }).catch(error=> console.log(error))
    },
    selectManagerAdd(){
      api.ipms.AttendanceManager.selectManagerAdd().then(data=>{
        this.attManagerTree=data
         console.log(data);
      }).catch(error=> console.log(error))
    },
    handleSubmit(then,error){
      this.$refs['attendanceManagerForm'].validate(valid => {
        if (valid) {
          if (this.attendanceManager.id) {
            this.updateAttendanceManager(this.attendanceManager).then(then).error(error)
          } else {
            this.createAttendanceManager(this.attendanceManager).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.attendanceManager.id = ''
      this.actionType = 'add';
      this.treeSelect();
      this.$nextTick(()=>this.$refs['attendanceManagerForm'].resetFields());
    },
    getAttendanceManager(id,type){
      this.loading = true;
      this.$refs['attendanceManagerForm'].resetFields()
      api.ipms.AttendanceManager.detail(id).then(data => {
      this.treeSelect();
        this.attendanceManager = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createAttendanceManager(attendanceManager){
      this.loading = true;
      return api.ipms.AttendanceManager.add(attendanceManager)
          .then(response => {
            this.loading = false;
            if(response.code==400){
              this.$Message.error(response.message)
            }else{
              this.$Message.success(response.message)
            }
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateAttendanceManager(attendanceManager){
      this.loading = true;
      return api.ipms.AttendanceManager.update(attendanceManager)
          .then(response => {
            this.loading = false;
            if(response.code==400){
              this.$Message.error(response.message)
            }else{
              this.$Message.success(response.message)
            }
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      userId: [{type: 'number', required: true, message: this.$t('ipms.attendance-manager.userId.holder'),trigger: 'blur'}],
      attendanceGroup: [{type: 'number', required: true, message: this.$t('ipms.attendance-manager.attendanceGroup.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('ipms.attendance-manager.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['attendanceManagerForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
